import { Outlet, Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const Layout = () => {
  const location = useLocation();
  const [navExpanded, setNavExpanded] = useState(false);

  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    setNavExpanded(false);
  }, [location]);

  return (
    <div className="d-flex flex-column min-vh-100">
      <header>
        <nav className="navbar navbar-expand-lg navbar-dark fixed-top bg-dark bg-primary">
          <div className="container">
            <Link className="navbar-brand" to="/" style={{ fontSize: "16px" }}>
              ASOCIAȚIA ONCOHEM CLUJ-NAPOCA
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarCollapse"
              aria-controls="navbarCollapse"
              aria-expanded={navExpanded}
              aria-label="Toggle navigation"
              onClick={() => setNavExpanded(!navExpanded)}
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className={`collapse navbar-collapse ${
                navExpanded ? "show" : ""
              }`}
              id="navbarCollapse"
            >
              <ul className="navbar-nav">
                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location.pathname === "/" ? "active" : ""
                    }`}
                    to="/"
                    onClick={() => setNavExpanded(false)}
                  >
                    Acasă
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location.pathname === "/evenimente" ? "active" : ""
                    }`}
                    to="/evenimente"
                    onClick={() => setNavExpanded(false)}
                  >
                    Evenimente
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location.pathname === "/opinie" ? "active" : ""
                    }`}
                    to="/opinie"
                    onClick={() => setNavExpanded(false)}
                  >
                    Opinie Medicală
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${
                      location.pathname === "/contact" ? "active" : ""
                    }`}
                    to="/contact"
                    onClick={() => setNavExpanded(false)}
                  >
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
      
      <main role="main" className="pb-3 flex-grow-1">
        <Outlet />
      </main>

      <footer className="footer mt-auto bg-light d-flex flex-wrap border-top">
        <div className="container d-flex align-items-center justify-content-center">
          <img
            src="images/aoc_logo_full.png"
            width="120"
            height="45"
            className="d-inline-block align-top"
            alt="Logo"
          />
          <span className="me-2">All Rights Reserved</span>
        </div>
      </footer>
    </div>
  );
};

export default Layout;